/** @jsxImportSource @emotion/react */
import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { AttachmentModalContent, AttachmentModalOverlay } from './AttachmentModal.styled';
import { AttachmentHeader } from './AttachmentModal.styled';
import { BreakLine } from './AttachmentModal.styled';
import { AttachmentItem } from './AttachmentModal.styled';

type AttachmentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onAttachFile?: () => void;
  onAttachPhoto?: () => void;
};

export const AttachmentModal: React.FC<AttachmentModalProps> = ({
  isOpen,
  onClose,
  onAttachFile,
  onAttachPhoto,
}) => {
  const handleFileAttach = () => {
    onAttachFile?.();
    onClose();
  };

  const handlePhotoAttach = () => {
    onAttachPhoto?.();
    onClose();
  };

  // Block background touch-scroll while the modal is open
  React.useEffect(() => {
    if (!isOpen) return;

    const preventScroll = (e: TouchEvent) => {
      e.preventDefault();
    };
    document.addEventListener('touchmove', preventScroll, { passive: false });

    return () => {
      document.removeEventListener('touchmove', preventScroll);
    };
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <AttachmentModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          />
          <AttachmentModalContent
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.2 }}
            onClick={(e) => e.stopPropagation()}
          >
            <AttachmentHeader>
              Attach
            </AttachmentHeader>
            <BreakLine />
            <AttachmentItem onClick={handleFileAttach}>File or document</AttachmentItem>
            <AttachmentItem onClick={handlePhotoAttach}>Take a photo</AttachmentItem>
          </AttachmentModalContent>
        </>
      )}
    </AnimatePresence>
  );
};